/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import addProductInformationFilter from "@stoneage/App/Handlers/Documents/addProductInformationFilter";
import removeProductInformationFilter from "@stoneage/App/Handlers/Documents/removeProductInformationFilter";
import { ProductDocumentsFacets } from "@stoneage/App/Services/Documents/DocumentsService";
import { CustomAppState } from "@stoneage/App/Store/Reducers";
import ProductInformationAccordion, {
    styles,
} from "@stoneage/App/Widgets/ProductInformation/ProductInformationFiltersAccordion";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    documentTypeFacets: state.xProductInfo.data?.documentTypeFacets,
});

const mapDispatchToProps = {
    addProductInformationFilter,
    removeProductInformationFilter,
};
const enum fields {
    title = "title",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}
type Props = OwnProps &
    Partial<WidgetProps> &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const ProductInformationTypeFilter = ({
    fields,
    addProductInformationFilter,
    removeProductInformationFilter,
    documentTypeFacets,
}: any) => {
    if (!documentTypeFacets || !documentTypeFacets.length) {
        return null;
    }

    const onChangeFacet = (facet: ProductDocumentsFacets) => {
        if (facet.selected) {
            removeProductInformationFilter({ filterType: "DocumentTypes", value: facet.name });
        } else {
            addProductInformationFilter({ filterType: "DocumentTypes", value: facet.name });
        }
    };

    return (
        <StyledWrapper {...styles.container}>
            <ProductInformationAccordion
                title={fields.title}
                facets={documentTypeFacets}
                onChangeFacet={onChangeFacet}
            />
        </StyledWrapper>
    );
};

export const DocumentTypeFilter = connect(mapStateToProps, mapDispatchToProps)(ProductInformationTypeFilter);

const widgetMoule: WidgetModule = {
    component: DocumentTypeFilter,
    definition: {
        displayName: "Document Type Filter",
        group: "Product Information" as any,
        allowedContexts: ["ProductInformationPage"] as any,
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "Filter By Type",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetMoule;
